<template>
  <div class="machine-user">
    <search-upgrade
      v-on:oneUpgrade="oneUpgrade"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :machineGroup="machineGroup"
      :selectList="selectList"
      :search="search"
    >
    </search-upgrade>
    <upgrade-version
      v-on:cancel="cancel"
      v-on:refreshContent="refreshContent"
      :MachineNo="localMachineNo"
      :upgradeType="upgradeType"
      :isOneUpdate="isOneUpdate"
      :dialogUpgrade="dialogUpgrade"
      :rowInfo="nowRowInfo"
      :isOneKey="isOneKey"
    >
    </upgrade-version>
    <div class="table vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        :row-class-name="tableRowClassName"
        :data="userMachineList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column type="selection" :selectable="selectable" width="40" :align="'center'"></el-table-column>
        <el-table-column
          prop="userName"
          :show-overflow-tooltip="true"
          :label="$t('machineUser.userName')"
          width="160"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('machineUser.equipmentNo')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          width="180"
          prop="equipmentName"
          :label="$t('machineUser.name')"
          :show-overflow-tooltip="true"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="mqState" :label="$t('machineUser.online')" width="100" :align="'center'" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.mqState == 1">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/zaixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: var(--vtm-ok); font-size: 13px">{{ $t("machineUser.onlinelabel1") }}</div>
              </div>
            </template>
            <template v-else-if="scope.row.mqState == 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/lixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: var(--vtm-crit); font-size: 13px">{{ $t("machineUser.onlinelabel2") }}</div>
              </div>
            </template>
            <template v-else>
              <div style="display: flex; justify-content: center; align-items: center">
                <div style="width: 10px; height: 10px; background-color: var(--vtm-line); border-radius: 100%; border: 2px solid var(--vtm-ink-3);"></div>
                <div style="margin-left: 5px; font-size: 13px">{{ $t("machineUser.onlinelabel3") }}</div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column width="180" prop="teamName" :label="$t('upgrade.teamId')" :align="'center'">
          <template #default="scope">
            {{ scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="vmcName"
          :show-overflow-tooltip="true"
          width="180"
          :label="$t('upgrade.Manage.740646-0')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="vmcVersion"
          :show-overflow-tooltip="true"
          width="180"
          :label="$t('upgrade.Manage.740646-1')"
          :align="'center'"
        ></el-table-column>
        <el-table-column width="100" prop="versionState" :label="$t('upgrade.vmcApply')" :align="'center'">
          <template #default="scope">
            <el-tag type="success" v-if="scope.row.versionState == 1">{{ $t("machineUser.yes") }}</el-tag>
            <el-tag type="danger" v-else>{{ $t("machineUser.no") }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="apkName"
          :show-overflow-tooltip="true"
          width="250"
          :label="$t('upgrade.localApp')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="apkVersion"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.localAppVersion')"
          :align="'center'"
          width="250"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'zh_CN' ? 196 : 250"
          :align="'center'"
        >
          <template slot-scope="scope">
            <!-- <el-progress :text-inside="true" :stroke-width="26" :percentage="70"></el-progress> -->
            <template v-if="scope.row.apkState == 1 || scope.row.vmcState == 1">
              <div v-if="scope.row.apkState == 1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">APK{{ $t("upgrade.sjzhong") }}</span>
                <span class="el-icon-loading"></span>
              </div>
              <div v-if="scope.row.vmcState == 1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">VMC{{ $t("upgrade.sjzhong") }}</span>
                <span class="el-icon-loading"></span>
              </div>
            </template>
            <template v-else-if="scope.row.apkState == 2 || scope.row.vmcState == 2">
              <div v-if="scope.row.apkState == 2" style="color: green; font-size: 13px">
                <span>APK{{ $t("upgrade.sjcg") }}</span>
              </div>
              <div v-if="scope.row.vmcState == 2" style="color: red">
                <span>VMC{{ $t("upgrade.sjcg") }}</span>
              </div>
            </template>
            <template v-else-if="scope.row.apkState == -1 || scope.row.vmcState == -1">
              <div v-if="scope.row.apkState == -1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">APK{{ $t("upgrade.sjsb") }}</span>
              </div>
              <div v-if="scope.row.vmcState == -1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">VMC{{ $t("upgrade.sjsb") }}</span>
              </div>
            </template>
            <template v-else>
              <el-button
                type="primary"
                icon="el-icon-upload"
                size="mini"
                v-hasPerm="['upgrade:version:apk']"
                @click="handleUpgradeApk(scope.row)"
                style="padding: 7px"
                >{{ $t("upgrade.upgradeApk") }}</el-button
              >
              <el-button
                type="warning"
                icon="el-icon-upload"
                size="mini"
                v-hasPerm="['upgrade:version:vmc']"
                @click="handleUpgradeFirmware(scope.row)"
                style="padding: 7px"
                >{{ $t("upgrade.upgradeFirmware") }}</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="(page.pageIndex == 1 && userMachineList.length > 1) || page.pageIndex != 1"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @current-change="currentChange"
        @size-change="sizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import SearchUpgrade from "_c/upgrade/SearchUpgrade.vue";
  import UpgradeVersion from "_c/upgrade/UpgradeVersion.vue";
  let timeoutIds = [];
  
  /**
   * APK/VMC Upgrade Tracking Configuration
   * 
   * This feature tracks machine upgrades and continues checking upgrade status
   * for a configurable duration after upgrade is initiated.
   * 
   * Configuration:
   * - UPGRADE_CHECK_DURATION: How long to keep checking (default: 48 hours)
   *   - 48 hours: 48 * 60 * 60 * 1000 = 172800000 ms
   *   - 7 days: 7 * 24 * 60 * 60 * 1000 = 604800000 ms
   * 
   * Polling Strategy (Exponential Backoff):
   * - First hour: Every 30 seconds
   * - 1-4 hours: Every 2 minutes
   * - 4-24 hours: Every 5 minutes
   * - 24-48 hours: Every 15 minutes
   * 
   * This reduces API calls significantly while still monitoring upgrades.
   * Memory usage is minimal as tracking data is stored in localStorage
   * and cleaned up automatically after the duration expires.
   */
  const UPGRADE_CHECK_DURATION = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
  const STORAGE_KEY_PREFIX = "apk_upgrade_tracking_";
  
  export default {
    name: "Manage",
    components: {
      UpgradeVersion,
      SearchUpgrade
    },
    data() {
      return {
        loading: false,
        machineGroup: [],
        userMachineList: [],
        page: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        search: {
          userName: "",
          equipmentNo: "",
          equipmentName: "",
          teamId: "",
          vmcName: "",
          apkVersion: "",
          sort: "",
          order: ""
        },
        dialogUpgrade: false,
        localMachineNo: "",
        upgradeType: "",
        selectList: [],
        isOneUpdate: 0,
        nowRowInfo: {},
        path: "",
        isOneKey: false,
        // Track upgrade status checks
        upgradeTracking: {} // { equipmentNo: { startTime, type, checkCount, lastInterval } }
      };
    },
    mounted() {
      this.path = this.$route.path;
      this.loadUpgradeTracking();
      this.listMachineGroup();
      this.currentChange();
      // Clean up old tracking data on mount
      this.cleanupOldTracking();
      // Start checking tracked upgrades
      this.startTrackedUpgradeChecks();
    },
    beforeMount() {
      this.clearTimer();
    },
    destroyed() {
      this.clearTimer();
      this.saveUpgradeTracking();
    },
    methods: {
      handleSelectionChange(val) {
        this.selectList = val;
      },
      refreshContent(type) {
        this.upgradeType = parseInt(type);
      },
      cancel(dialog, state) {
        this.dialogUpgrade = dialog;
        this.isOneUpdate = 0;
        if (state) {
          // When upgrade is initiated, track it
          if (state === "APK" && this.localMachineNo) {
            // Handle batch upgrades (comma-separated machine numbers)
            const machineNos = this.localMachineNo.split(",");
            machineNos.forEach(equipmentNo => {
              if (equipmentNo.trim()) {
                this.trackUpgradeStart(equipmentNo.trim(), "apk");
              }
            });
          } else if (state === "VMC" && this.localMachineNo) {
            // Handle batch upgrades (comma-separated machine numbers)
            const machineNos = this.localMachineNo.split(",");
            machineNos.forEach(equipmentNo => {
              if (equipmentNo.trim()) {
                this.trackUpgradeStart(equipmentNo.trim(), "vmc");
              }
            });
          }
          this.currentChange(this.page.pageIndex);
        }
      },
      // 开始暂停
      handlePlayPause(row, boolean) {
        console.log(row, boolean);
      },
      // 删除按钮
      handleDelete(row) {
        console.log(row);
      },
      // 获取设备分组
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      // 一键升级按钮
      oneUpgrade() {
        let _self = this;
        let selectList = this.selectList;
        let machineNoStr = "";
        selectList.forEach(item => {
          console.log(item);

          machineNoStr += item.id + ",";
        });
        machineNoStr = machineNoStr.slice(0, machineNoStr.length - 1);
        _self.localMachineNo = machineNoStr;
        _self.dialogUpgrade = true;
        _self.upgradeType = 1;
        _self.isOneUpdate = 1;
        _self.isOneKey = true;
      },
      // 升级APK
      handleUpgradeApk(row) {
        let _self = this;
        _self.localMachineNo = row.equipmentNo;
        _self.dialogUpgrade = true;
        _self.upgradeType = 1;
        _self.isOneKey = false;
      },
      // 升级VMC
      handleUpgradeFirmware(row) {
        let _self = this;
        _self.localMachineNo = row.equipmentNo;
        _self.dialogUpgrade = true;
        _self.upgradeType = 2;
        _self.nowRowInfo = row;
      },
      // 提交搜索按钮
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      // 提交重置按钮
      resetSearch(data) {
        this.search = data;
        // Clear sort parameters when resetting
        delete this.search.sort;
        delete this.search.order;
        this.currentChange();
      },
      sizeChange(size) {
        this.page.pageSize = size;
        this.currentChange();
      },
      sortChange(column) {
        const propToColumn = { mqState: "mq_state" };
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = propToColumn[column.prop] || column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = propToColumn[column.prop] || column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      // 加载列表内容
      currentChange(pageIndex) {
        let _self = this;
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.UserMachine.upPage, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              let listset = res.data.records;
              for (let i = 0; i < listset.length; i++) {
                const equipmentNo = listset[i]["equipmentNo"];
                const apkState = parseInt(listset[i]["apkState"]);
                const vmcState = parseInt(listset[i]["vmcState"]);
                
                // Check if machine is currently upgrading
                if (apkState == 1 || vmcState == 1) {
                  let biaoshi = "apkState";
                  if (apkState == 1) {
                    biaoshi = "apkState";
                  } else if (vmcState == 1) {
                    biaoshi = "vmcState";
                  }
                  _self.djsChange(equipmentNo, i, biaoshi);
                } else {
                  // Check if we should continue tracking this upgrade (even if not currently upgrading)
                  // This handles cases where upgrade might have failed but machine could still update
                  const shouldTrackApk = this.shouldContinueTracking(equipmentNo, "apk");
                  const shouldTrackVmc = this.shouldContinueTracking(equipmentNo, "vmc");
                  
                  if (shouldTrackApk && !shouldTrackVmc) {
                    _self.djsChange(equipmentNo, i, "apkState");
                  } else if (shouldTrackVmc && !shouldTrackApk) {
                    _self.djsChange(equipmentNo, i, "vmcState");
                  } else if (shouldTrackApk && shouldTrackVmc) {
                    // If both are tracked, prioritize APK
                    _self.djsChange(equipmentNo, i, "apkState");
                  }
                }
              }
              this.userMachineList = listset;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      djsChange(equipmentNo, i, biaoshi) {
        let that = this;
        let url = this.$url.Upgrade.appStatus;
        const upgradeType = biaoshi === "apkState" ? "apk" : "vmc";
        
        if (biaoshi == "apkState") {
          url = this.$url.Upgrade.appStatus;
        } else if (biaoshi == "vmcState") {
          url = this.$url.Upgrade.firmwareStatus;
        }

        // Check if we should continue tracking
        if (!this.shouldContinueTracking(equipmentNo, upgradeType) && 
            (!this.userMachineList[i] || parseInt(this.userMachineList[i][biaoshi]) !== 1)) {
          // Stop tracking if outside time window and not currently upgrading
          this.stopTracking(equipmentNo, upgradeType);
          return;
        }

        this.$api
          .request(url, this.$method.get, { equipmentNo: equipmentNo })
          .then(res => {
            if (res.code == 0 && res.data !== undefined) {
              // Update the status in the list if index is valid
              if (this.userMachineList[i]) {
                this.userMachineList[i][biaoshi] = res.data;
              }
              
              const status = parseInt(res.data);
              const isUpgrading = status === 1;
              const isCompleted = status === 2;
              const isFailed = status === -1;
              
              // Calculate next check interval using exponential backoff
              const nextInterval = this.getNextCheckInterval(equipmentNo, upgradeType);
              
              if (this.path == this.$route.path && this.shouldContinueTracking(equipmentNo, upgradeType)) {
                if (isUpgrading) {
                  // Still upgrading - check more frequently (every 5 seconds)
                  setTimeout(() => {
                    let timer = that.djsChange(equipmentNo, i, biaoshi);
                    timeoutIds.push(timer);
                  }, 5000);
                } else if (!isCompleted && !isFailed) {
                  // Not upgrading yet but within tracking window - check less frequently
                  setTimeout(() => {
                    let timer = that.djsChange(equipmentNo, i, biaoshi);
                    timeoutIds.push(timer);
                  }, nextInterval);
                } else if (isCompleted || isFailed) {
                  // Upgrade completed or failed - stop tracking after a short delay
                  setTimeout(() => {
                    that.stopTracking(equipmentNo, upgradeType);
                  }, 60000); // Wait 1 minute before stopping to ensure status is stable
                }
              }
            }
          })
          .catch(() => {
            // On error, continue checking but with longer interval
            if (this.shouldContinueTracking(equipmentNo, upgradeType) && this.path == this.$route.path) {
              const nextInterval = this.getNextCheckInterval(equipmentNo, upgradeType);
              setTimeout(() => {
                let timer = that.djsChange(equipmentNo, i, biaoshi);
                timeoutIds.push(timer);
              }, Math.min(nextInterval * 2, 300000)); // Max 5 minutes on error
            }
          });
      },
      //清除定时器
      clearTimer() {
        for (let i in timeoutIds) {
          clearTimeout(timeoutIds[i]);
        }
        timeoutIds = [];
      },
      // Track upgrade start time
      trackUpgradeStart(equipmentNo, upgradeType) {
        const key = `${equipmentNo}_${upgradeType}`;
        if (!this.upgradeTracking[key]) {
          this.upgradeTracking[key] = {
            startTime: Date.now(),
            type: upgradeType,
            checkCount: 0,
            lastInterval: 5000 // Start with 5 seconds
          };
          this.saveUpgradeTracking();
        }
      },
      // Check if we should continue tracking an upgrade
      shouldContinueTracking(equipmentNo, upgradeType) {
        const key = `${equipmentNo}_${upgradeType}`;
        const tracking = this.upgradeTracking[key];
        if (!tracking) {
          return false;
        }
        const elapsed = Date.now() - tracking.startTime;
        return elapsed < UPGRADE_CHECK_DURATION;
      },
      // Get next check interval with exponential backoff
      getNextCheckInterval(equipmentNo, upgradeType) {
        const key = `${equipmentNo}_${upgradeType}`;
        const tracking = this.upgradeTracking[key];
        if (!tracking) {
          return 30000; // Default 30 seconds
        }
        
        tracking.checkCount++;
        const elapsed = Date.now() - tracking.startTime;
        
        // Exponential backoff: increase interval over time
        // First hour: every 30 seconds
        // 1-4 hours: every 2 minutes
        // 4-24 hours: every 5 minutes
        // 24-48 hours: every 15 minutes
        let interval;
        if (elapsed < 3600000) { // First hour
          interval = 30000; // 30 seconds
        } else if (elapsed < 14400000) { // 1-4 hours
          interval = 120000; // 2 minutes
        } else if (elapsed < 86400000) { // 4-24 hours
          interval = 300000; // 5 minutes
        } else { // 24-48 hours
          interval = 900000; // 15 minutes
        }
        
        tracking.lastInterval = interval;
        return interval;
      },
      // Stop tracking an upgrade
      stopTracking(equipmentNo, upgradeType) {
        const key = `${equipmentNo}_${upgradeType}`;
        delete this.upgradeTracking[key];
        this.saveUpgradeTracking();
      },
      // Load upgrade tracking from localStorage
      loadUpgradeTracking() {
        try {
          const stored = localStorage.getItem(STORAGE_KEY_PREFIX + "data");
          if (stored) {
            this.upgradeTracking = JSON.parse(stored);
          }
        } catch (e) {
          console.error("Failed to load upgrade tracking:", e);
          this.upgradeTracking = {};
        }
      },
      // Save upgrade tracking to localStorage
      saveUpgradeTracking() {
        try {
          localStorage.setItem(STORAGE_KEY_PREFIX + "data", JSON.stringify(this.upgradeTracking));
        } catch (e) {
          console.error("Failed to save upgrade tracking:", e);
        }
      },
      // Clean up old tracking data
      cleanupOldTracking() {
        const now = Date.now();
        const keysToDelete = [];
        
        for (const key in this.upgradeTracking) {
          const tracking = this.upgradeTracking[key];
          if (now - tracking.startTime > UPGRADE_CHECK_DURATION) {
            keysToDelete.push(key);
          }
        }
        
        keysToDelete.forEach(key => {
          delete this.upgradeTracking[key];
        });
        
        if (keysToDelete.length > 0) {
          this.saveUpgradeTracking();
        }
      },
      // Start checking for tracked upgrades
      startTrackedUpgradeChecks() {
        // This will be called when machines are loaded in currentChange
        // We check tracked upgrades there
      }
    }
  };
</script>

<style lang="scss">
  .table {
    overflow: hidden;
  }
  .table .el-table .warning-row {
    background: var(--vtm-crit);
    color: #ffffff;
  }
  .table .el-table .hover-row {
    color: var(--vtm-ink-2);
  }
  .machine-user .image {
    position: absolute;
  }
  .machine-user .maturity {
    color: var(--vtm-crit);
  }
  .machine-user .renew {
    color: var(--vtm-ok);
  }
</style>
